import { render, staticRenderFns } from "./wealth.vue?vue&type=template&id=51669c7a&scoped=true&"
import script from "./wealth.vue?vue&type=script&lang=js&"
export * from "./wealth.vue?vue&type=script&lang=js&"
import style0 from "./wealth.vue?vue&type=style&index=0&id=51669c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51669c7a",
  null
  
)

export default component.exports